import { useEffect, useRef } from "react";

export default function ElectricDust() {
    const ref = useRef(null);

    useEffect(() => {
        const canvas = ref.current;
        const ctx = canvas.getContext("2d");
        let raf;
        let running = true;
        let w = 0;
        let h = 0;
        const dpr = Math.min(window.devicePixelRatio || 1, 1.5);

        const resize = () => {
            const r = canvas.parentElement.getBoundingClientRect();
            w = r.width;
            h = r.height;
            canvas.width = w * dpr;
            canvas.height = h * dpr;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        };
        resize();
        const ro = new ResizeObserver(resize);
        ro.observe(canvas.parentElement);

        const mobile = window.innerWidth < 640;
        const N = mobile ? 34 : 70;
        const pts = Array.from({ length: N }, () => ({
            x: Math.random() * w,
            y: Math.random() * h,
            vx: (Math.random() - 0.5) * 0.25,
            vy: (Math.random() - 0.5) * 0.25,
            r: Math.random() * 1.4 + 0.4,
            yellow: Math.random() < 0.3,
        }));

        const io = new IntersectionObserver(([e]) => (running = e.isIntersecting), {
            threshold: 0.02,
        });
        io.observe(canvas);

        const draw = () => {
            raf = requestAnimationFrame(draw);
            if (!running) return;
            ctx.clearRect(0, 0, w, h);
            for (let i = 0; i < N; i++) {
                const p = pts[i];
                p.x += p.vx;
                p.y += p.vy;
                if (p.x < -20) p.x = w + 20;
                if (p.x > w + 20) p.x = -20;
                if (p.y < -20) p.y = h + 20;
                if (p.y > h + 20) p.y = -20;
            }
            // links
            for (let i = 0; i < N; i++) {
                for (let j = i + 1; j < N; j++) {
                    const a = pts[i];
                    const b = pts[j];
                    const dx = a.x - b.x;
                    const dy = a.y - b.y;
                    const d2 = dx * dx + dy * dy;
                    if (d2 < 15000) {
                        const o = (1 - d2 / 15000) * 0.14;
                        ctx.strokeStyle = `rgba(255,230,0,${o * 0.55})`;
                        ctx.lineWidth = 0.6;
                        ctx.beginPath();
                        ctx.moveTo(a.x, a.y);
                        ctx.lineTo(b.x, b.y);
                        ctx.stroke();
                    }
                }
            }
            for (const p of pts) {
                ctx.fillStyle = p.yellow
                    ? "rgba(255,230,0,0.8)"
                    : "rgba(148,163,184,0.55)";
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
                ctx.fill();
            }
        };
        draw();

        return () => {
            cancelAnimationFrame(raf);
            ro.disconnect();
            io.disconnect();
        };
    }, []);

    return (
        <canvas
            ref={ref}
            className="absolute inset-0 w-full h-full pointer-events-none"
            aria-hidden
        />
    );
}
